
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TriggeredAction } from '@/api/model/triggered-action'
import { cloneDeep, isEqual } from 'lodash'

@Component
export default class CreateAutoActionFormStep4 extends Vue {
    @Prop({ required: true }) readonly value!: TriggeredAction
    editingValue: TriggeredAction = null

    @Watch('value', { immediate: true })
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
    }

    @Watch('editingValue.emptyField')
    @Watch('editingValue.actionComment')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    get emptyFieldOptions() {
        return [
            {
                label: this.$t('forms.triggered_action_form.empty_field_options.none'),
                value: null,
            },
            {
                label: this.$t('forms.triggered_action_form.empty_field_options.appointmentDatum'),
                value: 'appointmentDatum',
            },
            {
                label: this.$t('forms.triggered_action_form.empty_field_options.leadCommission'),
                value: 'leadCommission',
            },
            {
                label: this.$t('forms.triggered_action_form.empty_field_options.action'),
                value: 'action',
            },
            {
                label: this.$t('forms.triggered_action_form.empty_field_options.transportDate'),
                value: 'transportDate',
            },
        ]
    }

    get actionTypeLabel() {
        return this.$t(`action.type.${this.value.actionType}`)
    }

    get delayUnitLabel() {
        return this.$tc(`virtualColleague.autoAction.avatarHeader.delayUnit.${this.value.delayUnit}`, this.value.delayQuantity)
    }

    get actionAssignedToTypeLabel() {
        if (this.value.actionAssignToType === null) {
            return this.$t(`virtualColleague.autoAction.avatarHeader.actionAssignedToType.specific`)
        } else {
            return this.$t(`virtualColleague.autoAction.avatarHeader.actionAssignedToType.${ this.value.actionAssignToType }`)
        }
    }

    get avatarHeaderText() {
        if (this.value.actionType === 'add-to-pipeline') {
            return this.$t('virtualColleague.autoAction.avatarHeader.stepFourAddToPipeline', {
                pipeline: this.value.newReferralPipeline.name,
                phase: this.value.phase.name,
                branch: this.value.assignedToBranch.name,
            })
        } else if (this.value.actionType === 'reminder') {
            return this.$t('virtualColleague.autoAction.avatarHeader.stepFourActionReminder', {
                action: this.actionTypeLabel,
                time: this.value.delayQuantity,
                delay: this.delayUnitLabel,
                actionAssignToLabel: this.actionAssignedToTypeLabel,
            })
        } else {
            return this.$t('virtualColleague.autoAction.avatarHeader.stepFourAction', {
                action: this.actionTypeLabel,
                time: this.value.delayQuantity,
                delay: this.delayUnitLabel,
                actionAssignToLabel: this.actionAssignedToTypeLabel,
            })
        }
    }
}
